module.exports = __webpack_public_path__ + "fa3d6065aa1adff97ed2713e902f57ff.jpg";